import React from 'react';
import {
  IButtonProps,
  mergeStyleSets,
  PrimaryButton,
} from 'office-ui-fabric-react';
import { theme } from 'theme';

export default ({ styles, ...props }: IButtonProps) => (
  <PrimaryButton
    styles={mergeStyleSets(
      {
        root: {
          backgroundColor: theme.colors.themePrimary,
        },
        rootDisabled: {
          backgroundColor: '#F4F4F4 !important',
          color: '#A6A6A6 !important',
        },
      },
      styles
    )}
    {...props}
  />
);
